var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-item-status", class: { "is-compact": _vm.compact } },
    [
      _vm.compact
        ? _c("div", { staticClass: "status-summary" }, [
            _vm.showFulfillment
              ? _c("span", { staticClass: "status-chip" }, [
                  _vm._v(
                    _vm._s(_vm.snapshot.fulfillmentText || "履约状态待核实")
                  ),
                ])
              : _vm._e(),
            _vm.refundProgressVisible && _vm.snapshot.refundState !== "NONE"
              ? _c(
                  "span",
                  {
                    staticClass: "status-chip order-item-refund-status",
                    class: _vm.refundTone,
                  },
                  [
                    _c("span", { staticClass: "status-value" }, [
                      _vm._v(_vm._s(_vm.refundText)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.showReturnSummary
              ? _c("span", { staticClass: "status-chip order-item-return" }, [
                  _vm._v(
                    "退回：" +
                      _vm._s(_vm.snapshot.returnText || "退回进度待核实")
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        _vm.compact ? "el-tooltip" : "div",
        {
          ref: "statusTip",
          tag: "component",
          attrs: {
            effect: "light",
            placement: "right",
            "open-delay": 150,
            "popper-class": "order-item-status-tip",
          },
        },
        [
          _c(
            "div",
            {
              class: { "status-tip-content": _vm.compact },
              attrs: { slot: _vm.compact ? "content" : null },
              slot: _vm.compact ? "content" : null,
            },
            [
              _vm.compact && (_vm.productName || _vm.sku)
                ? _c("div", { staticClass: "status-tip-product" }, [
                    _vm.productName
                      ? _c("div", { staticClass: "tip-product-name" }, [
                          _vm._v(_vm._s(_vm.productName)),
                        ])
                      : _vm._e(),
                    _vm.sku
                      ? _c("div", { staticClass: "status-row" }, [
                          _c("span", { staticClass: "status-label" }, [
                            _vm._v("规格："),
                          ]),
                          _c("span", { staticClass: "status-value" }, [
                            _vm._v(_vm._s(_vm.sku)),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.showFulfillment
                ? _c(
                    "div",
                    { staticClass: "status-row order-item-fulfillment" },
                    [
                      _c("span", { staticClass: "status-label" }, [
                        _vm._v("履约："),
                      ]),
                      _c("span", { staticClass: "status-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.snapshot.fulfillmentText || "履约状态待核实"
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.refundProgressVisible
                ? _c(
                    "div",
                    {
                      staticClass: "status-row order-item-refund-status",
                      class: _vm.refundTone,
                    },
                    [
                      _c("span", { staticClass: "status-label" }, [
                        _vm._v("客户退款："),
                      ]),
                      _c("div", { staticClass: "status-content" }, [
                        _c("span", { staticClass: "status-value" }, [
                          _vm._v(_vm._s(_vm.refundText)),
                        ]),
                        _vm.snapshot.afterSalesTypeText || _vm.moneyText
                          ? _c("div", { staticClass: "status-detail" }, [
                              _vm.snapshot.afterSalesTypeText
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.snapshot.afterSalesTypeText)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.moneyText
                                ? _c("span", [_vm._v(_vm._s(_vm.moneyText))])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "status-row order-item-return" }, [
                _c("span", { staticClass: "status-label" }, [
                  _vm._v("商品退回："),
                ]),
                _c("span", { staticClass: "status-value" }, [
                  _vm._v(_vm._s(_vm.snapshot.returnText || "退回进度待核实")),
                ]),
              ]),
            ]
          ),
          _vm.compact
            ? _c(
                "button",
                {
                  staticClass: "status-tip-trigger",
                  attrs: {
                    type: "button",
                    "aria-label": "查看商品履约和售后明细",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.statusTip.show()
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      return _vm.$refs.statusTip.hide()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-info",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }